// removed by extract-text-webpack-plugin
module.exports = {"none":"src-components-modules-Image-style----radius-module---none---3PleW borderRadius-0","s":"src-components-modules-Image-style----radius-module---s---1nsyr borderRadius-s","m":"src-components-modules-Image-style----radius-module---m---10SHO borderRadius-m","l":"src-components-modules-Image-style----radius-module---l---28uEQ borderRadius-l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Image/style/radius.module.css
// module id = 1479
// module chunks = 168707334958949